import { createAction } from '@reduxjs/toolkit';
export var make = function (type) {
    return function (payloadCreator) {
        return createAction(type, payloadCreator);
    };
};
